import { getCanvasContext } from '@dealstack/frontend/app/pages/Valuations/shared/canvasContext';
import { assign, pick } from 'lodash';

/**
 * @deprecated Canvas API doesn't support `font-variant-numeric`. Use `calculateWidthUsingTextStyles` instead.
 */
export const getTextWidth = (text: string, font: string): number => {
	const context = getCanvasContext();
	if (!context) {
		return 0;
	}

	context.font = font;
	const metrics = context.measureText(text);
	return metrics.width;
};

export const getFont = (element: HTMLElement): string => {
	const style = window.getComputedStyle(element);
	const fontWeight = style.getPropertyValue('font-weight') ?? 'normal';
	const fontSize = style.getPropertyValue('font-size') ?? '16px';
	const fontFamily = style.getPropertyValue('font-family') ?? 'Times New Roman';

	return `${fontWeight} ${fontSize} ${fontFamily}`;
};

// Reusable hidden element for DOM-based text measurement
let measurementElement: HTMLElement | null = null;
const getMeasurementElement = (): HTMLElement => {
	if (!measurementElement) {
		measurementElement = document.createElement('span');
		measurementElement.style.visibility = 'hidden';
		measurementElement.style.position = 'absolute';
		measurementElement.style.top = '-9999px';
		measurementElement.style.left = '-9999px';
		measurementElement.style.whiteSpace = 'nowrap';
		measurementElement.style.pointerEvents = 'none';
		document.body.appendChild(measurementElement);
	}
	return measurementElement;
};

const TEXT_MEASUREMENT_PROPERTIES = [
	'fontFamily',
	'fontSize',
	'fontWeight',
	'fontStyle',
	'fontStretch',
	'fontVariant',
	'fontVariantCaps',
	'fontVariantLigatures',
	'fontVariantNumeric',
	'fontVariantEastAsian',
	'fontVariantAlternates',
	'fontFeatureSettings',
	'fontKerning',
	'letterSpacing',
	'wordSpacing',
	'textTransform',
	'textRendering',
	'fontOpticalSizing',
	'fontSizeAdjust',
] as const;

export const calculateWidthUsingTextStyles = (text: string, sourceElement: HTMLElement): number => {
	const hiddenElement = getMeasurementElement();
	const sourceStyle = window.getComputedStyle(sourceElement);

	assign(hiddenElement.style, pick(sourceStyle, TEXT_MEASUREMENT_PROPERTIES));
	hiddenElement.textContent = text;

	return hiddenElement.getBoundingClientRect().width;
};
